import styled from "styled-components";

export const DateMsgContainer = styled.div`
    //display: flex;
    font-size: 12px;
    justify-content: space-between;
    color:"#7C7C7D";
`
